import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { productApi } from "../api/productApi";

export default function ProductsList() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  // ✅ modal state
  const [specOpen, setSpecOpen] = useState(false);
  const [specLoading, setSpecLoading] = useState(false);
  const [specErr, setSpecErr] = useState("");
  const [specProduct, setSpecProduct] = useState(null); // { id, nameAz..., specs: [] }

  const getCreatedRaw = (x) =>
    x?.createDateUtc ??
    x?.createDate ??
    x?.createdDate ??
    x?.createdOn ??
    x?.created ??
    x?.dateCreated ??
    x?.insertedAt ??
    x?.created_time ??
    x?.createdTime ??
    null;

  const getCreatedTime = (x) => {
    const v = getCreatedRaw(x);
    if (!v) return null;
    const dt = new Date(v);
    const t = dt.getTime();
    return Number.isFinite(t) ? t : null;
  };

  const formatDateTime = (v) => {
    if (!v) return "-";
    const dt = new Date(v);
    if (Number.isNaN(dt.getTime())) return "-";

    const dd = String(dt.getDate()).padStart(2, "0");
    const mm = String(dt.getMonth() + 1).padStart(2, "0");
    const yyyy = dt.getFullYear();

    const hh = String(dt.getHours()).padStart(2, "0");
    const mi = String(dt.getMinutes()).padStart(2, "0");

    return `${dd}.${mm}.${yyyy} ${hh}:${mi}`;
  };

  const load = async () => {
    setLoading(true);
    setErr("");
    try {
      const res = await productApi.getAll();
      const list = (res.data || []).slice();

      // ✅ ən son əlavə olunan birinci
      list.sort((a, b) => {
        const ta = getCreatedTime(a);
        const tb = getCreatedTime(b);

        if (ta != null && tb != null) return tb - ta;
        if (ta != null && tb == null) return -1;
        if (ta == null && tb != null) return 1;

        // fallback: id desc
        return (Number(b?.id) || 0) - (Number(a?.id) || 0);
      });

      setItems(list);
    } catch (e) {
      setErr(e?.response?.data || e.message || "Load failed");
      setItems([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const onDelete = async (id) => {
    if (!window.confirm("Silinsin?")) return;
    try {
      await productApi.remove(id);
      await load();
    } catch (e) {
      alert(e?.response?.data || e.message || "Delete failed");
    }
  };

  // ✅ Spec modal aç
  const openSpecs = async (x) => {
    setSpecErr("");
    setSpecLoading(false);

    // əvvəl list item-də specs varsa göstər
    if (Array.isArray(x?.specs) && x.specs.length >= 0) {
      setSpecProduct({
        id: x.id,
        nameAz: x.nameAz,
        nameEn: x.nameEn,
        nameRu: x.nameRu,
        specs: x.specs || [],
      });
      setSpecOpen(true);
      return;
    }

    // yoxdursa detal çək
    setSpecProduct({
      id: x.id,
      nameAz: x.nameAz,
      nameEn: x.nameEn,
      nameRu: x.nameRu,
      specs: [],
    });
    setSpecOpen(true);

    setSpecLoading(true);
    try {
      const res = await productApi.get(x.id);
      const full = res.data || null;
      setSpecProduct((p) => ({
        ...p,
        ...(full || {}),
        specs: full?.specs || [],
      }));
    } catch (e) {
      setSpecErr(e?.response?.data || e.message || "Specs yüklənmədi");
    } finally {
      setSpecLoading(false);
    }
  };

  const closeSpecs = () => {
    setSpecOpen(false);
    setSpecErr("");
    setSpecLoading(false);
    setSpecProduct(null);
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 12,
        }}
      >
        <h1 className="pageTitle" style={{ margin: 0 }}>
          Məhsullar
        </h1>
        <Link className="btn btnPrimary" to="/products/new">
          Yenisini yarat
        </Link>
      </div>

      <div style={{ marginTop: 14 }}>
        {loading ? (
          <div className="card">
            <div className="cardBody">Yüklənir...</div>
          </div>
        ) : err ? (
          <div className="card">
            <div className="cardBody" style={{ color: "rgba(255,77,79,.9)" }}>
              {String(err)}
            </div>
          </div>
        ) : (
          <div className="tableWrap">
            <table className="table">
              <thead>
                <tr>
                  <th style={{ width: 60 }}>#</th>
                  <th style={{ width: 90 }}>Məhsulun ID-si</th>
                  <th>Adı</th>
                  <th>Məhsul haqqında</th>
                  <th style={{ width: 120 }}>Yaradılma tarixi</th>
                  <th style={{ width: 120 }}>Qiyməti</th>
                  <th style={{ width: 150 }}>Şəkil</th>
                  <th style={{ width: 260 }}>Əməliyyat</th>
                </tr>
              </thead>

              <tbody>
                {items.map((x, index) => {
                  const createdRaw = getCreatedRaw(x);
                  return (
                    <tr key={x.id}>
                      <td>{index + 1}</td>
                      <td style={{ fontWeight: 800, whiteSpace: "nowrap" }}>
                        {x.id}
                      </td>

                      <td style={{ fontWeight: 800 }}>
                        <div>
                          <span style={{ opacity: 0.75 }}>AZ:</span>{" "}
                          {x.nameAz ?? ""}
                        </div>
                        <div>
                          <span style={{ opacity: 0.75 }}>EN:</span>{" "}
                          {x.nameEn ?? ""}
                        </div>
                        <div>
                          <span style={{ opacity: 0.75 }}>RU:</span>{" "}
                          {x.nameRu ?? ""}
                        </div>
                      </td>

                      <td style={{ maxWidth: 520 }}>
                        <div style={{ marginBottom: 6 }}>
                          <span style={{ opacity: 0.75 }}>AZ:</span>{" "}
                          <span
                            style={{
                              opacity: x.descAz ? 1 : 0.55,
                            }}
                          >
                            {x.descAz ?? "-"}
                          </span>
                        </div>
                        <div style={{ marginBottom: 6 }}>
                          <span style={{ opacity: 0.75 }}>EN:</span>{" "}
                          <span
                            style={{
                              opacity: x.descEn ? 1 : 0.55,
                            }}
                          >
                            {x.descEn ?? "-"}
                          </span>
                        </div>
                        <div>
                          <span style={{ opacity: 0.75 }}>RU:</span>{" "}
                          <span
                            style={{
                              opacity: x.descRu ? 1 : 0.55,
                            }}
                          >
                            {x.descRu ?? "-"}
                          </span>
                        </div>
                      </td>

                      <td
                        style={{
                          whiteSpace: "nowrap",
                          opacity: createdRaw ? 1 : 0.6,
                        }}
                      >
                        {formatDateTime(createdRaw)}
                      </td>

                      <td>{x.price ?? "-"}</td>

                      <td>
                        {x.hasImage ? (
                          <img
                            className="imgThumb"
                            alt="product"
                            src={
                              productApi.getImageUrl(x.id) + `?t=${Date.now()}`
                            }
                          />
                        ) : (
                          <span className="badge badgeNo">Şəkil yoxdur</span>
                        )}
                      </td>

                      <td>
                        <div className="btnRow" style={{ flexWrap: "wrap" }}>
                          <button
                            className="btn"
                            type="button"
                            onClick={() => openSpecs(x)}
                            title="Specs"
                          >
                            Spec
                          </button>

                          <Link className="btn" to={`/products/${x.id}/edit`}>
                            Redakte et
                          </Link>

                          <button
                            className="btn btnDanger"
                            type="button"
                            onClick={() => onDelete(x.id)}
                          >
                            Sil
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}

                {items.length === 0 ? (
                  <tr>
                    <td colSpan="7" style={{ color: "rgba(255,255,255,.6)" }}>
                      Heç nə yoxdur.
                    </td>
                  </tr>
                ) : null}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* ✅ MODAL: SPECS */}
      {specOpen ? (
        <div
          onClick={closeSpecs}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,.55)",
            display: "grid",
            placeItems: "center",
            padding: 16,
            zIndex: 9999,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="card"
            style={{
              width: "min(980px, 96vw)",
              maxHeight: "85vh",
              overflow: "auto",
            }}
          >
            <div
              className="cardBody"
              style={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "space-between",
                gap: 12,
              }}
            >
              <div>
                {/* <div style={{ fontWeight: 900, fontSize: 18 }}>
                  Specs — Product #{specProduct?.id}
                </div>

                <div style={{ marginTop: 8, opacity: 0.85 }}>
                  <div>
                    <b>AZ:</b> {specProduct?.nameAz ?? "-"}
                  </div>
                  <div>
                    <b>EN:</b> {specProduct?.nameEn ?? "-"}
                  </div>
                  <div>
                    <b>RU:</b> {specProduct?.nameRu ?? "-"}
                  </div>
                </div> */}
              </div>

              <button
                className="btn btnDanger"
                type="button"
                onClick={closeSpecs}
              >
                Bağla
              </button>
            </div>

            <div className="cardBody" style={{ paddingTop: 0 }}>
              {specLoading ? (
                <div style={{ opacity: 0.8 }}>Yüklənir...</div>
              ) : specErr ? (
                <div style={{ color: "rgba(255,77,79,.9)" }}>
                  {String(specErr)}
                </div>
              ) : (specProduct?.specs || []).length === 0 ? (
                <div style={{ opacity: 0.8 }}>Spec yoxdur.</div>
              ) : (
                <div className="tableWrap">
                  <table className="table">
                    <thead>
                      <tr>
                        <th style={{ width: 60 }}>#</th>
                        <th>Açar sözü</th>
                        <th>Məzmunu</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(specProduct?.specs || []).map((s, i) => (
                        <tr key={s?.id ?? i}>
                          <td>{i + 1}</td>

                          <td style={{ fontWeight: 800 }}>
                            <div>
                              <span style={{ opacity: 0.75 }}>AZ:</span>{" "}
                              {s.keyAz ?? "-"}
                            </div>
                            <div>
                              <span style={{ opacity: 0.75 }}>EN:</span>{" "}
                              {s.keyEn ?? "-"}
                            </div>
                            <div>
                              <span style={{ opacity: 0.75 }}>RU:</span>{" "}
                              {s.keyRu ?? "-"}
                            </div>
                          </td>

                          <td>
                            <div>
                              <span style={{ opacity: 0.75 }}>AZ:</span>{" "}
                              {s.valueAz ?? "-"}
                            </div>
                            <div>
                              <span style={{ opacity: 0.75 }}>EN:</span>{" "}
                              {s.valueEn ?? "-"}
                            </div>
                            <div>
                              <span style={{ opacity: 0.75 }}>RU:</span>{" "}
                              {s.valueRu ?? "-"}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}
